<template>
  <v-flex xs12 md6 class="mascoteBoasVinda">
    <div class="agrupaMascote">
      <div class="valorMascote"><strong>{{valores.percent}}%</strong></div>
      <div class="imgMascote"> <img :src="imgMascote" alt="mascote-25.png">
        <div class="colorMaskMascote" v-bind:style="{ height: valores.percent + '%' }" v-bind:class="{ 'bg0': bg0, 'bg25': bg25, 'bg50': bg50, 'bg65': bg65, 'bg75': bg75, 'bg85': bg85, 'bg100': bg100, 'bgErro':bgErro }"></div>
      </div>
    </div>
    <div class="msgMascote" v-show="!esconderMsg">
  
      <h3 class="text-primary"><strong>Não se Esqueça!</strong></h3>
      <h4><strong  class="text-cinza-9">
        <span class="text-red font-size-18">*</span>{{valores.msg}}</strong></h4>
    </div>
  </v-flex>
</template>

<script>
   export default {
     props: {//Propriedades que o objeto recebe como parametro
       msg: String,
       esconderMsg:Boolean,
       valores: Object,
       model: Object, /*Solicitacao atual do Fornecedor*/
       erros: Object
     },
     watch: { //Propriedades assistidas
       model: {
         handler() {
           clearTimeout(this.timeOut);
           this.timeOut = setTimeout(() => {
             this.definiPercent();
           }, this.tempoTimeOut);
         },
         deep: true
       }
     },
     name: "mascote",
     data() {//Declaracao de variaveis
        return {
          imgMascote: "/images/mascote-25.png",
          timeOut: Object,
          tempoTimeOut: 300,
          intervalo: Object,
          removeCampos:[
            "qualificacaoTecnica",
            "numFax",
            "nomFantasia",
            "endEmail3",
            "endEmail2",
            "inss",
            "dataValidadeInss",
            "dataSolicitacao",
            "fgts",
            "dataValidadeFgts",
            "sefaz",
            "dataValidadeSefaz",
            "sefazba",
            "dataValidadeSefazba",
            "sefazFornecedor",
            "dataValidadeSefazFornecedor",
            "sefazpms",
            "dataValidadeSefazpms",
            "trabalhista",
            "dataValidadeTrabalhista",
            "statusSolicitacao",
            "arquivo",
            "tbFornecedores",
            "motivoNaoHabilitacao",
            "familiasSimpas",
            "nomSocial",
            "sitFornecedor",
            "dataAnalise",
            "senha",
            "nomCidadeEstrangeira",
            "nomAnalista",
            "nomCadastrador", 
            "cpfCadastrador",
            "nomUFEstrangeira",
            "endCepEstrangeiro",
            "usuarioCadastrador", 
            "usuarioAnalistaId", 
            "usuarioAnalista", 
            "motivoExclusao",
            "codSecretaria",
            "numUnidade",
            "emailCadastrador",
            "telCadastrador",
            "idMotivoIndeferimentoArquivo",
            "dtArquivoUploadRejeicao",
            "dataSolicitacaoRejeitado",
            "numProcedimentoSEI",
            "linkProcedimentoSEI", 
            "numDocumentoSEI",
            "ultimaSolicitacaoSimpas",
            "dataCriacao",
            "dataCancelamentoPorPrazo",
            "usuarioCadastradorId",
            "motivoDeIndeferimento",
            "motivoIndeferimentoStr",
            "vwSrhCargaFuncionario",
            "isFuncionarioPublico",
            "modeloUltimaSolicitacaoSimpas",
            "termoConcordanciaVeracidade",
            "flagCriacaoProcedimentoSEI",
            "codDocumentoSIMPAS",
            "arquivoUpload",
            "arquivoUploadSituacao",
            "motivoAlteracaoCertificado",
            "flagEstrangeiro",
            "anexoRelatorioInscricaoRegistro",
            "rgRepresentanteLegal",
            "razaoSocialRepresentanteLegal",
            "cnpjRepresentanteLegal",
            "enderecoRepresentanteLegal",
            "bairroRepresentanteLegal",
            "cidadeRepresentanteLegal",
            "estadoRepresentanteLegal",
            "cepRepresentanteLegal",
            "celularRepresentanteLegal",
            "telRepresentanteLegal",
            "emailRepresentanteLegal",
            "solicitacaoVencida",
            "listaDocsQualificacaoTecnica",            
            "endComplemento",
            "docRelatorioRegistroCadastral",
            "representanteLegal",
            "docRelatorioRegistroCadastral",  
            "documentosSolicitacao",            
            "numSolicitacao",
            "unidadeSolicitante",           
            "indRecEmails",
            "numSolicitacao",
            "flagSociedadeAnonima",
            "finalidadeEmpresa"           
        ],
          bg0: true,
          bg25: false,
          bg50: false,
          bg65: false,
          bg75: false,
          bg85: false,
          bg100: false,
          bgErro:false,
       };
     },
     created() /*Metodo de start do componente*/{
       this.definiPercent();
     },
     methods: {//Declaracao de todos os metodos
       definiPercent() {

        let obj = Object.assign({},this.model);
        
        this.removeCampos.forEach((item)=>{
          delete obj[item];
        })
        if(this.model.tipoCertificado != 1)
        {
          delete obj["balancoFinanceiro"];
        }
        var Soma = 0;
        
        if (obj) {
          const keys = Object.keys(obj);
          Soma = keys.length;
        } 
        // 2 é do upload declaração
       
        
		   if(this.model.tipoCertificado == 3)
        {
         var quantidade = Soma + 6;
        }
        else if(this.model.tipoCertificado == 2)
        {
          var quantidade = Soma + 7;
        }
        else if(this.model.tipoCertificado == 1)
        {
          var quantidade = Soma + 8 + 16 + 9;
        }
        else{
          var quantidade = Soma + 6;
        }

         var total = 0;
         var percent = 0;

         clearInterval(this.intervalo);
          
         total = this.calculaTotal(obj, total);                
         if(total > quantidade)
          {
            total = quantidade;
          }
       
         if (total) {
           percent = Math.trunc((total / quantidade ) * 100).toFixed(1);
           this.valores.percent = 0;
           this.intervalo = setInterval(() => {
             this.valores.percent++;
             this.bg0 = false;
             this.bg25 = false;
             this.bg50 = false;
             this.bg65 = false;
             this.bg75 = false;
             this.bg85 = false;
             this.bg100 = false;
             this.imgMascote = "/images/mascote-25.png";

            this.setPercentMascote();

            if(this.erros.erro){
               this.bgErro = true;
            }else{
               this.bgErro = false;
            }
              // percent é do tipo string e valores.percent é number
             if (this.valores.percent == percent) {
               clearInterval(this.intervalo);
             }
           }, 10);           
         }
       },

       calculaTotal(obj, total){
           
          for (var propriedade in obj) {
              
           if (obj[propriedade] != null && obj[propriedade] != "" && obj[propriedade] != [] && obj[propriedade] != {} && obj[propriedade] != 0) {
             total++;                         
           }
         
           
         }          
            if(this.model.tipoCertificado == 1)
          {
          var x = 0;
           for (var propriedade in obj.balancoFinanceiro) {
              
              if (obj.balancoFinanceiro[propriedade] != null && obj.balancoFinanceiro[propriedade] != "" && obj.balancoFinanceiro[propriedade] != [] && obj.balancoFinanceiro[propriedade] != {}) {
                total++; 
                x++;    
               
              }
                     
            }  
        
            for (var propriedade in obj.concordataFalencia) {              
              if (obj.concordataFalencia[propriedade] != null && obj.concordataFalencia[propriedade] != "" && obj.concordataFalencia[propriedade] != [] && obj.concordataFalencia[propriedade] != {} ) {
                total++;  

              }    
                      
            }  
          }
         var Soma = 0;
        
          if (obj.regularidadeFiscTrab) {
            const keys = Object.keys(obj.regularidadeFiscTrab);
            Soma = keys.length;
          } 
              
         return total + Soma;
       },

       setPercentMascote(){

       
        if (this.valores.percent < 25) {
          this.bg0 = true;
        }
        if (this.valores.percent >= 25 && this.valores.percent < 50) {
          this.imgMascote = "/images/mascote-25.png";
          this.bg25 = true;
        }
        if (this.valores.percent >= 50 && this.valores.percent < 65) {
          this.imgMascote = "/images/mascote-50.png";
          this.bg50 = true;
        }
        if (this.valores.percent >= 65 && this.valores.percent < 75) {
          this.imgMascote = "/images/mascote-65.png";
          this.bg65 = true;
        }
        if (this.valores.percent >= 75 && this.valores.percent < 85) {
          this.imgMascote = "/images/mascote-75.png";
          this.bg75 = true;
        }
        if (this.valores.percent >= 85 && this.valores.percent < 100) {
          this.imgMascote = "/images/mascote-85.png";
          this.bg85 = true;
        }
        if (this.valores.percent >= 100) {
          this.imgMascote = "/images/mascote-100.png";
          this.bg100 = true;
        }
       }
     }
   };
</script>

<style>
   .bg0 {
     background-color: #ffab91 !important;
   }
   .bg25 {
     background-color: #ddb542 !important;
   }
   .bg50 {
     background-color: #cddc39 !important;
   }
   .bg65 {
     background-color: #dcedc8 !important;
   }
   .bg75 {
     background-color: #dcedc8 !important;
   }
   .bg85 {
     background-color: #c5e1a5 !important;
   }
   .bg100 {
     background-color: #66bb6a !important;
   }
   .bgErro {
   background-color: rgba(215, 44, 44, 0.4)!important;
background: rgba(215, 44, 44, 0.4)!important;
color: rgba(215, 44, 44, 0.4)!important;
   }
</style>